/**
 * JobMockAI — Admin Route Guard
 *
 * Wraps routes that require ADMIN or SUPER_ADMIN role.
 * Renders children if the user is an admin, otherwise redirects to "/".
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}
        data-testid="admin-loading-spinner"
      >
        <CircularProgress size={48} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const role = (user?.role || '').toLowerCase();
  if (role !== 'admin' && role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
